export default {
  state: {
    title: 'Stan',
    visible: 'Zamawianie przy stoliku widoczne',
    on: 'Zamawianie przy stoliku',
  },
  notes: {
    hidden: {
      title: 'Zamawianie przy stoliku jest ukryte',
      description:
        'Funkcja jest włączona, ale Twój sklep jej nie wyświetla, więc każde zamówienie przy stoliku jest odrzucane. Włącz „Zamawianie przy stoliku widoczne”, aby ją pokazać.',
      link: 'Przejdź do przełącznika',
    },
    off: {
      title: 'Goście nie mogą teraz zamawiać przy stoliku',
      description:
        'Włącz oba przełączniki, aby zacząć. Do tego czasu kod QR stolika otwiera Twój sklep z opcjami Odbiór i Dostawa.',
    },
    no_active_table: {
      title: 'Goście nie mogą jeszcze zamawiać przy stoliku',
      description: 'Dodaj poniżej stolik i włącz go.',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
};
